var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"pt-3 pl-3"},[_c('b-col',[_c('h3',[_vm._v("error 404")]),_c('span',[_vm._v("La url solicitada no existe")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }